import {Collections, Firebase, selectFeatureFlagView} from '@ozark/common';
import {FlagName} from '@ozark/functions/src/documents/FeatureFlag';
import {useEffect, useState} from 'react';

interface FeatureFlags {
  [key: string]: boolean;
}

const STORAGE_KEY = 'feature_flags';

export const useFeatureFlag = (featureKey: FlagName) => {
  const {isEnabled} = useFeatureFlags();
  return isEnabled(featureKey);
};

export const useFeatureFlags = () => {
  const [localFlags, setLocalFlags] = useState<FeatureFlags>({});
  const [firebaseFlags, setFirebaseFlags] = useState<FeatureFlags>({});

  useEffect(() => {
    try {
      const storedFlags = localStorage.getItem(STORAGE_KEY);
      if (storedFlags) {
        const parsedFlags: FeatureFlags = JSON.parse(storedFlags);
        setLocalFlags(parsedFlags);
      }
    } catch (error) {
      console.error('Error reading feature flags from localStorage:', error);
    }
  }, []);

  useEffect(() => {
    const unsubscribe = Firebase.firestore.collection(Collections.featureFlags).onSnapshot(
      snapshot => {
        const flags: FeatureFlags = {};

        snapshot.docs.forEach(doc => {
          const featureFlagData = selectFeatureFlagView(doc as any);
          if (featureFlagData.flag && featureFlagData.enabled !== undefined) {
            flags[featureFlagData.flag] = featureFlagData.enabled;
          }
        });

        setFirebaseFlags(flags);
      },
      error => {
        console.error('Error fetching feature flags from Firebase:', error);
      }
    );

    return () => unsubscribe();
  }, []);

  const isEnabled = (flagName: FlagName): boolean => {
    if (localFlags[flagName] !== undefined) {
      return localFlags[flagName];
    }
    return firebaseFlags[flagName] ?? false;
  };

  return {isEnabled};
};
